export const SET_CURRENT_DOCUMENTS = 'SET_CURRENT_DOCUMENTS';


export const setCurrentDocuments = (documents) => {
    return {
        type: SET_CURRENT_DOCUMENTS,
        documents
    }
}
